import { WsSelectObj } from 'wisestep-base';

import { IBreadCrumbsList } from '../../components/WsBreadCrumbs';
import { TitleAndBreadCrumbs } from '../invoicing/helper/InvocieSettingsHelper';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../teams/helper/defaultValues';

export const booleanSelect: WsSelectObj[] = [
  { label: 'True', value: 'true' },
  { label: 'False', value: 'false' },
];
export const analyticsDropdown: WsSelectObj[] = [
  { label: 'None', value: '' },
  {
    label: 'Workspace',
    value: 'WORKSPACE',
  },
  {
    label: 'Team',
    value: 'TEAM',
  },
  {
    label: 'User',
    value: 'USER',
  },
];

export type AccessControlSettingType =
  | 'ATS_ACCESS'
  | 'USER_ACCESS'
  | 'TEAMS_ACCESS'
  | 'JOBS_ACCESS'
  | 'CANDIDATE_ACCESS'
  | 'NATIVE_SEARCH_ACEESS'
  | 'PREMIUM_JOB_BOARDS_ACCESS'
  | 'VMS_ACCESS'
  | 'SMS_ACCESS'
  | 'ATTRIBUTE_VISIBILITY'
  | 'COMPOSSABLE_ANALYTICS_ACCESS'
  | 'CLIENT_LISTING_ACCESS'
  | 'INVOICING_AND_PLACEMENT_ACCESS'
  | 'ORGANIZATION_ENTITY_ACCESS'
  | 'CRM_JOB_ACCESS'
  | 'LEAD_ACCESS'
  | 'CLIENT_CONTACTS_ACCESS';

const ACCESS_CONTROL_SETTINGS_BREAD_CRUMBS: IBreadCrumbsList[] = getSettingBreadCrumbList(
  ISettingBreadCrumbTypes.ACCOUNT,
  Pages['ACCESS_CONTROL_SETTINGS']
);

const getBreadCrumbList = (type: AccessControlSettingType) => [
  ...ACCESS_CONTROL_SETTINGS_BREAD_CRUMBS,
  Pages[type],
];

export const AccessContolBreadCrumbListAndTitle: Record<
  AccessControlSettingType,
  TitleAndBreadCrumbs
> = {
  ATS_ACCESS: {
    Title: 'ATS Access Control',
    BreadcrumbsList: getBreadCrumbList('ATS_ACCESS'),
  },
  USER_ACCESS: {
    Title: 'Users Access',
    BreadcrumbsList: getBreadCrumbList('USER_ACCESS'),
  },
  TEAMS_ACCESS: {
    Title: 'Teams Access',
    BreadcrumbsList: getBreadCrumbList('TEAMS_ACCESS'),
  },
  JOBS_ACCESS: {
    Title: 'Jobs Access',
    BreadcrumbsList: getBreadCrumbList('JOBS_ACCESS'),
  },
  CANDIDATE_ACCESS: {
    Title: 'Candidate Access',
    BreadcrumbsList: getBreadCrumbList('CANDIDATE_ACCESS'),
  },
  NATIVE_SEARCH_ACEESS: {
    Title: 'Native Search Access Control',
    BreadcrumbsList: getBreadCrumbList('NATIVE_SEARCH_ACEESS'),
  },
  PREMIUM_JOB_BOARDS_ACCESS: {
    Title: 'Premium Job Board Access',
    BreadcrumbsList: getBreadCrumbList('PREMIUM_JOB_BOARDS_ACCESS'),
  },
  VMS_ACCESS: {
    Title: 'VMS Configuration',
    BreadcrumbsList: getBreadCrumbList('VMS_ACCESS'),
  },
  SMS_ACCESS: {
    Title: 'SMS Configuration',
    BreadcrumbsList: getBreadCrumbList('SMS_ACCESS'),
  },
  ATTRIBUTE_VISIBILITY: {
    Title: 'Attribute Visibility',
    BreadcrumbsList: getBreadCrumbList('ATTRIBUTE_VISIBILITY'),
  },
  COMPOSSABLE_ANALYTICS_ACCESS: {
    Title: 'Composable Analytics Access Control',
    BreadcrumbsList: getBreadCrumbList('COMPOSSABLE_ANALYTICS_ACCESS'),
  },
  CLIENT_LISTING_ACCESS: {
    Title: 'Client Listing Access Control',
    BreadcrumbsList: getBreadCrumbList('CLIENT_LISTING_ACCESS'),
  },
  INVOICING_AND_PLACEMENT_ACCESS: {
    Title: 'Invoicing and Placement Access Control',
    BreadcrumbsList: getBreadCrumbList('INVOICING_AND_PLACEMENT_ACCESS'),
  },
  ORGANIZATION_ENTITY_ACCESS: {
    Title: 'Organization Entity Access Control',
    BreadcrumbsList: getBreadCrumbList('ORGANIZATION_ENTITY_ACCESS'),
  },
  CRM_JOB_ACCESS: {
    Title: 'CRM Jobs Access Control',
    BreadcrumbsList: getBreadCrumbList('CRM_JOB_ACCESS'),
  },
  LEAD_ACCESS: {
    Title: 'Lead Access Control',
    BreadcrumbsList: getBreadCrumbList('LEAD_ACCESS'),
  },
  CLIENT_CONTACTS_ACCESS: {
    Title: 'Client Contacts Access Control',
    BreadcrumbsList: getBreadCrumbList('CLIENT_CONTACTS_ACCESS'),
  },
};

export const expansionConfig = {
  VIEW: true,
  ADD: false,
  EDIT: false,
  DELETE: false,
};
